module.exports = __webpack_public_path__ + "static/media/traveler-background-from-publisher.6acb4500.md";